export const errors: Record<string, string> = {
  OptimisticLockingException:
    'This visit is out of sync as someone else has modified it, please reload the page and redo your changes.',
};
